import React from 'react'
import { ReimpressaoCapa } from '@newspacebpo/mf_protocolo_bfveic'
const ReimpressaoCapaPage = (props) => {
    return (
            <ReimpressaoCapa {...props}/>
    );
};

export { ReimpressaoCapaPage };